"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEntityFieldExpression = exports.isString = void 0;
var range_1 = __importDefault(require("lodash/range"));
function isString(data) {
    return typeof data === 'string';
}
exports.isString = isString;
var isValidEntityFieldExpression = function (entities, entity, fieldExpr) {
    if (!entities[entity]) {
        return false;
    }
    var viewFieldRefPath = fieldExpr.split('.');
    var entityField = entities[entity].fields[viewFieldRefPath[0]];
    if (!entityField) {
        return false;
    }
    if (viewFieldRefPath.length === 1) {
        return true;
    }
    else {
        var nextEntity = entities[entity].fields[viewFieldRefPath[0]].relatedEntity;
        if (isString(nextEntity)) {
            return (0, exports.isValidEntityFieldExpression)(entities, nextEntity, (0, range_1.default)(1, viewFieldRefPath.length)
                .map(function (i) { return viewFieldRefPath[i]; })
                .join('.'));
        }
        return false;
    }
};
exports.isValidEntityFieldExpression = isValidEntityFieldExpression;
//# sourceMappingURL=index.js.map